import clsx from "clsx";
import { KTSVG } from "../../../helpers";
import { ThemeModeComponent } from "../../../assets/ts/layout";
import { useStyleContext } from "../../../helpers/StyleContext";
import { ThemeModeType, useThemeMode } from "../theme-mode/ThemeModeProvider";
import { useIntl } from "react-intl";

/* eslint-disable jsx-a11y/anchor-is-valid */
type Props = {
  toggleBtnClass?: string;
  toggleBtnIconClass?: string;
  menuPlacement?: string;
  menuTrigger?: string;
};

const systemMode = ThemeModeComponent.getSystemMode() as "light" | "dark";

const ThemeModeSwitcherMenu = ({
  toggleBtnIconClass = "svg-icon-2",
  menuPlacement = "left-start",
  menuTrigger = "{default: 'click', lg: 'hover'}",
}: Props) => {
  const { mode, menuMode, updateMode, updateMenuMode } = useThemeMode();
  const { styleState } = useStyleContext();
  const calculatedMode = mode === "system" ? systemMode : mode;
  const intl = useIntl();

  menuTrigger =
    styleState.type !== "custom" ? "{default: 'click', lg: 'hover'}" : "";

  const switchMode = (_mode: ThemeModeType) => {
    updateMenuMode(_mode);
    updateMode(_mode);
  };

  return (
    <div>
      {/* begin::Menu toggle */}
      <div
        className="menu-item px-5"
        data-kt-menu-trigger={menuTrigger}
        data-kt-menu-attach="parent"
        data-kt-menu-target="theme_mode_menu"
        data-kt-menu-placement={menuPlacement}
      >
        <a
          className={clsx("menu-link px-5 my-1 gap-2", {
            "text-hover-primary": styleState.toolbar_text_color,
          })}
          style={{ color: styleState?.toolbar_text_color }}
        >
          {intl.formatMessage({
            id: "MENU.PROFILE.PROFILEHEADER.THEME",
          })}

          {calculatedMode === "dark" && (
            <KTSVG
              path="/media/icons/duotune/general/gen061.svg"
              className={clsx("theme-light-hide", toggleBtnIconClass)}
              color={styleState?.header_text_color}
            />
          )}

          {calculatedMode === "light" && (
            <KTSVG
              path="/media/icons/duotune/general/gen060.svg"
              className={clsx("theme-dark-hide", toggleBtnIconClass)}
              color={styleState?.header_text_color}
            />
          )}

          {calculatedMode === "custom" && (
            <KTSVG
              path="/media/icons/duotune/coding/cod003.svg"
              className={clsx("theme-dark-hide", toggleBtnIconClass)}
              color={styleState?.header_text_color}
            />
          )}
        </a>
      </div>
      {/* begin::Menu toggle */}

      {/* begin::Menu */}
      <div
        className={clsx(
          "menu menu-sub menu-sub-dropdown menu-column menu-rounded  menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-175px",
          { "menu-title-gray-700": !styleState.toolbar_text_color }
        )}
        // className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-175px"
        data-kt-menu="true"
        id="theme_mode_menu"
        style={{
          color: styleState?.toolbar_text_color,
          backgroundColor: styleState?.toolbar_background_color,
        }}
      >
        {styleState.type !== "custom" && (
          <>
            {/* begin::Menu item */}
            <div className="menu-item px-3 my-0">
              <a
                href="#"
                className={clsx("menu-link px-3 py-2", {
                  active: menuMode === "light",
                })}
                onClick={() => switchMode("light")}
              >
                <span className="menu-icon" data-kt-element="icon">
                  <KTSVG
                    path="/media/icons/duotune/general/gen060.svg"
                    className="svg-icon-3"
                    color={styleState?.toolbar_text_color}
                  />
                </span>
                <span
                  className={clsx("menu-title", {
                    "text-hover-primary": styleState.toolbar_text_color,
                  })}
                  style={{ color: styleState?.toolbar_text_color }}
                >
                  Light
                </span>
              </a>
            </div>
            {/* end::Menu item */}

            {/* begin::Menu item */}
            <div className="menu-item px-3 my-0">
              <a
                href="#"
                className={clsx("menu-link px-3 py-2", {
                  active: menuMode === "dark",
                })}
                onClick={() => switchMode("dark")}
              >
                <span className="menu-icon" data-kt-element="icon">
                  <KTSVG
                    path="/media/icons/duotune/general/gen061.svg"
                    className="svg-icon-3"
                    color={styleState?.toolbar_text_color}
                  />
                </span>
                <span
                  className={clsx("menu-title", {
                    "text-hover-primary": styleState.toolbar_text_color,
                  })}
                  style={{ color: styleState?.toolbar_text_color }}
                >
                  Dark
                </span>
              </a>
            </div>
            {/* end::Menu item */}
          </>
        )}

        {/* begin::Menu item */}
        {styleState.type !== "light_dark" && (
          <div className="menu-item px-3 my-0">
            <a
              href="#"
              className={clsx("menu-link px-3 py-2", {
                active: menuMode === "custom",
              })}
              onClick={() => switchMode("custom")}
            >
              <span className="menu-icon" data-kt-element="icon">
                <KTSVG
                  path="/media/icons/duotune/coding/cod003.svg"
                  className="svg-icon-3"
                  color={styleState?.toolbar_text_color}
                />
              </span>
              <span
                className={clsx("menu-title", {
                  "text-hover-primary": styleState.toolbar_text_color,
                })}
                style={{ color: styleState?.toolbar_text_color }}
              >
                Custom
              </span>
            </a>
          </div>
        )}
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </div>
  );
};

export { ThemeModeSwitcherMenu };
